import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { ReplaceTextPipe } from '../../pipes/replace-text.pipe';
import { StoryblokImage } from '../../storyblok-types';
import { BlockStyle, BlockWrapperComponent, getPageWidth } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-image',
  standalone: true,
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  imports: [CommonModule, BlockWrapperComponent, PictureComponent, ReplaceTextPipe],
})
export class ImageComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;

  @Input() style: BlockStyle[];
  @Input() image: StoryblokImage;
  @Input() mobileImage: StoryblokImage;
  @Input() shadowBox: boolean;
  @Input() loading: string;

  dimensions: {
    width: number;
    height: number;
  };

  mobileDimensions: {
    width: number;
    height: number;
  };

  maxWidth: number;

  ngOnChanges() {
    this.maxWidth = getPageWidth(this.style?.[0]?.pageWidth, this.style?.[0]?.customPageWidth);
    const url = this.image?.filename;
    if (!url) return;
    this.dimensions = {
      width: parseInt(url.split('/')[5].split('x')[0]),
      height: parseInt(url.split('/')[5].split('x')[1]),
    };
    if (!this.mobileImage) return;
    const mobileUrl = this.mobileImage?.filename;
    if (!mobileUrl) return;
    this.mobileDimensions = {
      width: parseInt(mobileUrl.split('/')[5].split('x')[0]),
      height: parseInt(mobileUrl.split('/')[5].split('x')[1]),
    };
  }
}
